import ErpButton from './ErpButton'
import { ErpDiv, ErpP } from './ErpHtml'
import { supportedLocales, localeDirection } from '@/config/locales'

export function LocaleStartupError({ locale, retry }: { locale: string; retry: () => void }) {
  const language = supportedLocales.find(item => item.code === locale) ?? supportedLocales[0]
  return <ErpDiv role="alert" dir={localeDirection(language.code)} className="mx-auto max-w-md space-y-4 p-6 text-center">
    <ErpP>{language.loadError}</ErpP>
    <ErpButton onClick={retry}>{language.retryLabel}</ErpButton>
  </ErpDiv>
}
